import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import { zoomInDown } from 'react-animations';
import { lightSpeedIn } from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import Fade from 'react-reveal/Fade';



const styles = {
  zoomInDown: {
    animation: 'x 5s',
    animationName: Radium.keyframes(zoomInDown, 'zoomInDown')
  }
}

const stylesLigh = {
  lightSpeedIn: {
    animation: 'x 5s',
    animationName: Radium.keyframes(lightSpeedIn, 'lightSpeedIn')
  }
}





class ActionRSE extends Component {
 constructor(props) {
    super(props);
    this.state = { show: false, show1:false, show2:false, show3:false };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(b) {
    if (b===1){
      this.setState({ show: !this.state.show });
    }
    
    
   

   
  }




  render() {
    return (
    <div>   
  <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg6.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Nos réalisations Rse ?</span>
                    </div>
                </div>
            </div>
        </section>


         <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
          

            <div className="row inside_content">
            <h3 className="text-center"><img src="/assets/img/leaf.png" className="leaf-sidebar"/>  Nos réalisations Rse</h3> 
     <div className="row">
     
      <div className="col-md-6">
      <StyleRoot>
        <div className="card pricing style2 boxShadow  boxShadow_rse" style={styles.zoomInDown}>
            <div className="card-block card_block_rse">
             <img src="/assets/img/feuille.png" className="leaf rse_leaf"/>

            <h4 className="key_rse">Réalisation d’une couverture en charpente sur la cour de la paroisse Sainte Anne de Bel-Air à Dakar</h4>  
            <p><b className="keywords">Green Agro Business</b> est entrain réaliser, sur la cour de <b className="keywords">l’église Sainte Anne de Bel-Air</b>, une couverture en charpente métallique d’une <b className="keywords">superficie de 715 m2 et d’une hauteur de 6m sur les versants</b>. La charpente est constituée de <b className="keywords">Tubes ronds DN  150  pour les poteaux, des IPE de 180, des BACS ALUS</b>   et accessoires.</p>  
            <p>La  structure permettra d’accroître la capacité et les conditions d’accueil des fidèles lors des cérémonies religieuses et culturelles.</p>
  

            </div>
          </div>
          </StyleRoot>
    </div>

    <div className="col-md-6">
    <StyleRoot>
          <div className="card pricing style boxShadow boxShadow_rse" style={styles.zoomInDown}>
            <div className="card-block card_block_rse">
             <img src="/assets/img/feuille.png" className="leaf rse_leaf"/>
                 <h4 className="key_rse">Finition des travaux de construction de la grande mosquée du village de <b className="keywords">Keur Matar</b> situé dans la commune de <b className="keywords">Keur Moussa à Thiès</b>.</h4>  
                    <p><b className="keywords">Green Agro Business</b> est également entrain de réaliser la finition des travaux de construction  de <b className="keywords">la grande mosquée du village de Keur Matar  situé dans la commune de Keur Moussa.</b></p>
                     <p className="fini">Les travaux de finition seront constitués de :</p>  
                    
                        
                         <div className="card_block_rsecontent">
                          <Fade bottom collapse when={this.state.show}>
                          <p><i className="fa fa-check-circle"></i>La reprise des dômes des deux minarets </p>
                            <p><i className="fa fa-check-circle"></i>La construction d’une fosse septique de 12 m3</p>
                            <p><i className="fa fa-check-circle"></i>La fourniture et pose de 1 800 m2 de carreaux (sol et faïence)</p>
                            <p><i className="fa fa-check-circle"></i>La fourniture et pose d’étanchéité</p>
                            <p><i className="fa fa-check-circle"></i>La fourniture et pose de 600m2 de moquettes</p>
                            <p><i className="fa fa-check-circle"></i>La peinture de la mosquée</p>
                            <p><i className="fa fa-check-circle"></i>La fourniture et pose de 12 haut-parleurs et accessoires</p>
                            <p><i className="fa fa-check-circle"></i>La fourniture et pose de lampes, ventilos et lustres pour décoration</p>
                            <p >Ces travaux de finition de la mosquée de Keur Matar constituent pour les populations un grand soulagement.</p>                      
              
                          </Fade>
                       </div>
                  <button
                      className="btn btn-md btn-black-line rsocial"
                      type="button"
                      onClick={()=>this.handleClick(1)}>
                      { this.state.show ? 'Fermer' : 'Voir plus' }
                  </button>



                         


            </div>
          </div>
          </StyleRoot>
    </div>
   
    </div>

    


</div>


</div>



</section>

    </div>
    )
  }
}
export default ActionRSE;


// WEBPACK FOOTER //
// ./src/components/rse.jsx